import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-amber text-brown font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300 text-lg md:text-xl w-full md:w-auto ${className}`} data-id="element-1">
      {children}
    </motion.button>;
}